import React from "react";
import { motion } from "framer-motion";

const headerVariants = {
  hidden: { opacity: 0, y: -30 },
  visible: { opacity: 1, y: 0 },
};

// Simple header for authentication page
const DevelopmentUpdatesHeader: React.FC = () => (
  <motion.section
    className="relative global-container z-5 text-center flex flex-col items-center mb-[8.55rem]"
    variants={headerVariants}
    initial="hidden"
    animate="visible"
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    <h1 className="h3 text-white mb-[1.2rem]">Development Updates</h1>
    <p className="text-white max-w-[81rem] w-full">
      Access your personalized development updates by entering your plot number
      and password below.
    </p>
  </motion.section>
);

export default DevelopmentUpdatesHeader;
